import es from '@/internationalization/trans/chefs/es/es.json';
export default {
  trans: es,
};
